import { render, staticRenderFns } from "./WizardSuccess.vue?vue&type=template&id=bbd47ede&scoped=true"
import script from "./WizardSuccess.vue?vue&type=script&lang=js"
export * from "./WizardSuccess.vue?vue&type=script&lang=js"
import style0 from "./WizardSuccess.vue?vue&type=style&index=0&id=bbd47ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd47ede",
  null
  
)

export default component.exports